import { useQuery } from "react-query";
import { SCHEDULE_DRAFT_AGENT_NAME } from "../lib/agentTrackUtils";
import { scheduleDraftQueryKeys } from "./queryKeys";
import { scheduleDraftDataService } from "../services/scheduleDraftDataService";

export function useScheduleDraftAgentStrategies(options = {}) {
    return useQuery(
        scheduleDraftQueryKeys.agentStrategies(SCHEDULE_DRAFT_AGENT_NAME),
        () => scheduleDraftDataService.getAgentStrategyPrompts(),
        {
            staleTime: 60000,
            refetchOnWindowFocus: false,
            ...options,
        },
    );
}

export default useScheduleDraftAgentStrategies;
